<template>
   <div class="row">
 
            <!--begin::Form-->
 		<div class="col-md-12">
										<div class="form-group m-form__group">
                    <input type="text"  :class="{ 'is-invalid': $v.user.email.$error }" v-model="user.email" class="form-control m-input log-inp m-login__form-input--last" placeholder="Eposta giriniz." />
										</div>
									</div>
 

           <div class="col-md-12">
									 
											<button type="button" id="m_login_signin_submit" @click="resetMyPassword" class="btn btn-primary btn-login-prm login-btn">Şifre Gönder</button>
											
								 
									 
									</div>
              
                   
                   



 
   </div>   
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import {_resetMyPassword} from '../../services/UserService'

export default {

  data() {
    return {
      user:{
        email:'',
      } 
    }

  },
    validations: {
    user: { 
           email: { required , email},
           
          
    }
  },
methods: {
 resetMyPassword:function(){
          this.$v.user.$touch();
      if (this.$v.user.$error) return;
          // let loader=this.$loading.show();
    _resetMyPassword(this.user).then(response=>{
      // loader.hide();
      
      if(response.data.success)
        this.$router.push({ name: '/' })
    });
  },
  
},
};
</script>

<style lang="scss" scoped>
.login-btn{
  border-radius:18px;
  margin-top: 13px;
}
</style>